{
    "especial": {
        "titulo": "Suggeriment / Consulta",
        "conf_consulta": "Hola! Moltes gràcies pel teu suggeriment/consulta. El Comitè Ètic s'encarregarà d'estudiar la teva proposta. Et mantindrem informat sobre qualsevol avanç en el cas, així com sobre la decisió final.!"
    },
    "actions": {
        "close": "Tancar",
        "send": "Enviar",
        "toattach": "Documentació/Evidència",
        "save": "Guardar",
        "clean": "Netejar",
        "singin": "Iniciar sessió",
        "restore": "Recuperar",
        "return": "Tornar",
        "confirm": "Acceptar",
        "cancel": "Cancel·lar",
        "access": "Accedir",
        "create": "Crear",
        "cerrarFase": "Tancar fase",
        "listen": "Escoltar"
    },
    "forms": {
        "title": "Què necessita fer?",
        "fraseinicial": "MOLT IMPORTANT: Si la denúncia pot afectar l'Administrador de la societat o algun dels membres del Comitè Ètic, si us plau utilitzi sempre el formulari de denúncia ANONIMA. Addicionalment, pot dirigir-se a nosaltres per a conèixer més sobre el nostre Comitè Ètic i la resta del nostre Sistema de Compliance, a través de les vies ordinàries de contacte amb la nostra organització.",
        "subtitle": "Aquí pot comunicar-nos incidències o plantejar-nos dubtes relatius a incompliments legals, incompliments de les nostres directrius i procediments o incompliments de qualsevol altre tipus",
        "subtitle2": "Aquest no és un servei d'emergència. Davant qualsevol perill imminent, dirigeixi's a les autoritats competents",
        "complaintsChannel": "Canal de Denúncies",
        "consult": "Consulta",
        "anonymous": "Anònima",
        "nominal": "Nominal",
        "voice": "Veu",
        "voice_record": "Iniciar gravació",
        "voice_stop": "Aturar gravació",
        "voice_recording ": "Gravant...",
        "voice_recorded ": "Gravació completada",
        "voice_instructions": "<strong>Avis:</strong> La veu no serà distorsionada.",
        "voice_error": "Error en accedir al micròfon. Si us plau, assegureu-vos que heu concedit els permisos necessaris i que el vostre dispositiu té un micròfon funcional.",
        "complaint": "Denúncia",
        "finalMesssage": "Vostè pot consultar l'estat de la mateixa a través de la url: ",
        "finalMesssage2": "Introduint el següent codi: ",
        "finalMessage3": "Pot imprimir una còpia o guardar com pdf fent ",
        "finalDenuncia": "Si desitja fer un seguiment de l'evolució de la denúncia ha de guardar l'enllaç i el codi que apareixen en pantalla.",
        "finalDenuncia2": "Li recomanem que accedeixi a la seva denúncia amb freqüència per a comprovar si ens hem posat en contacte amb vostè.",
        "typeChannel": "Què desitja fer?",
        "typeComplaint": "Tipus de delicte",
        "answer": "Resposta",
        "email": "Correu electrònic",
        "name": "Nom",
        "user": "Usuari",
        "password": "Contrasenya",
        "privacity": "He llegit i accepto la ",
        "privacity2": "He llegit la ",
        "capa1_GEN": "Resp. Tractament: ",
        "capa2_GEN": ". Finalitat: Seguiment, gestió i resolució de la sol·licitud rebuda a través del canal ètic. Exercici de drets i més informació sobre el tractament de les dades: ",
        "capa1_1": "De conformitat amb les normatives de protecció de dades, li facilitem la següent informació del tractament:",
        "capa1_2": "Responsable: HEALTH TIME, S.L. (D'ara endavant HT MEDICA).",
        "capa1_3": "Fins del tractament: gestionar adequadament el nostre canal ètic, tramitant les corresponents irregularitats notificades a través d'aquest",
        "capa1_4": "Drets que li assisteixen: accés, rectificació, portabilitat, supressió, limitació i oposició",
        "capa1_5": "Més informació del tractament en la nostra política de privacitat",
        "capa1_6": "El seu consentiment és necessari per al tractament posterior d'aquestes dades en el procediment i sense els quals no seria possible tramitar la seva sol·licitud.",
        "anonimato": "Per a mantenir l'anonimat, es recomana només pujar arxius en format pdf ",
        "policy": "Política de Privacitat",
        "consultation": {
            "name": "Nom",
            "surname": "Cognoms",
            "phone": "Telèfon",
            "email": "Correu electrònic",
            "ordinario": "Correu ordinari",
            "otromedia": "Un altre mitjà de comunicació?",
            "anompo": "Anonimitzat per ",
            "mediocom": "Mitjà de comunicació",
            "otros": "Uns altres",
            "organization": "Organització a la qual pertany",
            "relationship": "Quina relació té?",
            "message": "Quina és la seva consulta/denuncia?",
            "nature": "Naturalesa de la consulta/denuncia",
            "notificacionMensaje": "Rebre notificacions per ",
            "bloquear": "Està el Responsable del Canal (Compliance Officer) o l'Òrgan de Govern involucrat en els fets denunciats? ",
            "bloqueoOrgano": "Si, l'Òrgan de Govern (NO rebrà notificació de la denúncia)",
            "bloqueoOffice": "Si, el Compliance Officer (NO rebrà notificació de la denúncia)",
            "bloquearEsp": "Està el Responsable del Canal  o el Rol Suplent involucrat en els fets denunciats? ",
            "bloqueoOrganoEsp": "Si, el Rol Suplent (NO rebrà notificació de la denúncia)",
            "bloqueoOfficeEsp": "Si, el Responsable del Canal (NO rebrà notificació de la denúncia)",
            "defajenos": "La seva denúncia serà anonimitzada per incloure dades personals alienes als fets denunciats. Si us plau, enviï de nou la denúncia sense incloure aquestes dades.",
            "defsensibles": "La seva denúncia serà anonimitzada per incloure dades personals pertanyents a les categories especials de dades. Si us plau, enviï de nou la denúncia sense incloure aquestes dades."
        },
        "comp": {
            "whatComp": "Quina és la seva denúncia?",
            "involved": "Persona/s implicada/s",
            "involved2": "Si desconeix la identitat de la/s persona/s implicada/s escrigui `Ho desconec`",
            "department": "Departament afectat",
            "headquarters": "Seu afectada",
            "otherComplaints": "Descripció de la denúncia",
            "other": "Detall altres delictes",
            "nature": "Naturalesa de la denúncia",
            "when": "Quan ha ocorregut l'incident?",
            "reiterativo": "L'incident és reiteratiu?",
            "yes": "Si",
            "no": "No",
            "bloqmiembro": "Bloquejar Membre"
        },
        "principalBreadCrumb": "Consulta o Denúncia",
        "profile": "Veure perfil",
        "settings": "Configuració",
        "contact": "Contacte",
        "signout": "Tancar sessió",
        "imgText": "Arrossegament i deixi anar els documents o premi aquí"
    },
    "login": {
        "user": "Nom d'usuari",
        "password": "Contrasenya",
        "forgot": "No recorda la seva contrasenya?",
        "title": "Identificació de super usuari",
        "titleEmp": "Identificació d'empresa",
        "titleUser": "Identificació d'usuari",
        "restore": "Recuperar",
        "titleRestore": "Recuperar contrasenya",
        "finalMesssage": "S'ha recuperat la seva contrasenya.",
        "restoreFail": "Ha ocorregut un error, intentelo de nou.",
        "email": "Correu electrònic",
        "errorUsu": "Nom d'usuari o contrasenya incorrectes",
        "errorBlock": "L'usuari està bloquejat, posi's en contacte amb un administrador per a desbloquejar-lo",
        "restoreFailEmail": "El format de l'email no és vàlid"
    },
    "error": {
        "name": "El nom és un camp obligatori",
        "user": "L'usuari és un camp obligatori"
    },
    "menu": {
        "complaintsChannel": "Complaints Channel",
        "mcompany": "CREAR EMPRESA",
        "msuperuser": "CREAR SUPERUSUARIO",
        "roleMain": "MANTENIMENT de rols",
        "countryMain": "MANTENIMENT DE PAÏSOS",
        "offenseMain": "MANTENIMENT DE DELICTES",
        "mainLanguages": "MANTENIMENT D'IDIOMES",
        "fontMain": "MANTENIMENT DE FONTS",
        "relation": "MANTENIMENT DE RELACIONS",
        "nature": "MANTENIMENT DE NATURALESES",
        "headquarters": "MANTENIMENT DE SEUS",
        "departments": "MANTENIMENT DE DEPARTAMENTS",
        "users": "MANTENIMENT D'USUARIS",
        "mydata": "LES MEVES DADES",
        "statistics": "ESTADÍSTIQUES",
        "whistleblower": "DENUNCIANT",
        "history": "HISTORIAL DE CASOS",
        "ocases": "CASOS OBERTS",
        "title": "Hola",
        "mylinks": "ELS MEUS ENLLAÇOS",
        "notice": "ELS MEUS AVISOS",
        "noticemin": "Els meus avisos",
        "searcher": "CERCADOR",
        "config": "CONFIGURACIÓ",
        "changep": "CANVI DE CONTRASENYA"
    },
    "maintenance": {
        "actions": {
            "add": "Agregar",
            "cancel": "Cancel·lar",
            "confirm": "Acceptar"
        },
        "languages": {
            "title": "Manteniment d'idiomes",
            "name": "Nom",
            "key": "Codi",
            "deleteTitle": "Esborrant idioma {name}",
            "deleteMessage": "Està segur que desitja eliminar l'idioma?",
            "deleteConfirmTitle": "L'idioma ha estat eliminat",
            "deleteConfirm": "L'idioma ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant idioma {name}",
            "editMessage": "L'idioma ha estat editat",
            "addTitle": "Agregant nou idioma"
        },
        "countries": {
            "title": "Manteniment de països",
            "name": "Nom",
            "id": "Codi",
            "deleteTitle": "Esborrant país {name}",
            "deleteMessage": "Està segur que desitja eliminar el país?",
            "deleteConfirmTitle": "El país ha estat eliminat",
            "deleteConfirm": "El país ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant país {name}",
            "editMessage": "El país ha estat editat",
            "addTitle": "Agregant nou país"
        },
        "natures": {
            "title": "Manteniment de naturaleses",
            "name": "Nom",
            "deleteTitle": "Esborrant naturalesa {name}",
            "deleteMessage": "Està segur que desitja eliminar la naturalesa?",
            "deleteConfirmTitle": "La naturalesa ha estat eliminada",
            "deleteConfirm": "La naturalesa ha estat eliminada",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant naturalesa {name}",
            "editMessage": "La naturalesa ha estat editada",
            "addTitle": "Agregant nova naturalesa"
        },
        "relations": {
            "title": "Manteniment de relacions",
            "name": "Nom",
            "deleteTitle": "Esborrant relació {name}",
            "deleteMessage": "Està segur que desitja eliminar la relació?",
            "deleteConfirmTitle": "La relació ha estat eliminada",
            "deleteConfirm": "La relació ha estat eliminada",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant relació {name}",
            "editMessage": "La relació ha estat editada",
            "addTitle": "Agregant nova relació"
        },
        "superusers": {
            "title": "Super usuari",
            "name": "Nom",
            "id": "Codi",
            "email": "Correu electrònic",
            "password": "Contrasenya",
            "state": "Estat",
            "deleteTitle": "Esborrant super usuari {name}",
            "deleteMessage": "Està segur que desitja eliminar el super usuari?",
            "deleteConfirmTitle": "El super usuari ha estat eliminat",
            "deleteConfirm": "El super usuari ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant super usuari {name}",
            "editMessage": "El super usuari ha estat editat",
            "addTitle": "Agregant nou super usuari",
            "lock": "Desbloquejar"
        },
        "companies": {
            "title": "Empreses",
            "name": "Nom",
            "cif": "CIF",
            "email": "Correu electrònic",
            "password": "Contrasenya",
            "direction": "Direcció",
            "population": "Població",
            "cp": "CP",
            "user": "Usuari",
            "province": "Província",
            "group": "A quin grup pertany?",
            "logo": "Logotip",
            "designType": "Tipus de disseny",
            "companyType": "Tipus d'empresa",
            "lang": "Idioma",
            "state": "Estat",
            "single": "Única",
            "iGroup": "És grup?",
            "belongs": "Pertany",
            "country": "País",
            "isGroup": "Pertany a un grup?",
            "is-group": "Grup?",
            "deleteTitle": "Esborrant empresa {name}",
            "deleteMessage": "Està segur que desitja eliminar l'empresa?",
            "deleteConfirmTitle": "L'empresa ha estat eliminat",
            "deleteConfirm": "L'empresa ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant empresa {name}",
            "editMessage": "L'empresa ha estat editat",
            "addTitle": "Agregant nova empresa",
            "imgText": "Arrossegui i deixi anar la imatge o premi aquí",
            "unlock": "Desbloquejar",
            "lock": "Bloquejar",
            "link": "Link canal denuncies:",
            "typeRed": "Tipus vermell",
            "typeBlue": "Tipus blau",
            "typeGreen": "Tipus verd",
            "typeOrange": "Tipus taronja"
        },
        "fonts": {
            "title": "Manteniment de fonts",
            "name": "Nom",
            "deleteTitle": "Esborrant relació {name}",
            "deleteMessage": "Està segur que desitja eliminar la font?",
            "deleteConfirmTitle": "La font ha estat eliminada",
            "deleteConfirm": "La font ha estat eliminada",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant font {name}",
            "editMessage": "La font ha estat editada",
            "addTitle": "Agregant nova font"
        }
    },
    "mCompany": {
        "users": {
            "title": "Manteniment d'usuaris",
            "name": "Nom",
            "password": "Contrasenya",
            "email": "Correu electrònic",
            "dni": "DNI",
            "user": "Usuari",
            "governingBody": "Òrgan de govern",
            "compliance": "Compliance Officer",
            "rol": "Seleccionar un rol",
            "rolTable": "Rol",
            "deleteTitle": "Esborrant usuari {name}",
            "deleteMessage": "Està segur que desitja eliminar l'usuari?",
            "deleteConfirmTitle": "L'usuari ha estat eliminat",
            "deleteConfirm": "L'usuari ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant usuari {name}",
            "editMessage": "L'usuari ha estat editat",
            "addTitle": "Agregant nou usuari",
            "state": "Estat",
            "signature": "Té signatura digital?"
        },
        "departments": {
            "title": "Manteniment de departaments",
            "name": "Nom",
            "deleteTitle": "Esborrant departament {name}",
            "deleteMessage": "Està segur que desitja eliminar el departament?",
            "deleteConfirmTitle": "El departament ha estat eliminat",
            "deleteConfirm": "El departament ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant departament {name}",
            "editMessage": "El departament ha estat editat",
            "addTitle": "Agregant nou departament"
        },
        "headquarters": {
            "title": "Manteniment de seus",
            "name": "Nom",
            "deleteTitle": "Esborrant seu {name}",
            "deleteMessage": "Està segur que desitja eliminar la seu?",
            "deleteConfirmTitle": "La seu ha estat eliminat",
            "deleteConfirm": "La seu ha estat eliminat",
            "deleteError": "Ha ocorregut un error mentre esborrava",
            "editTitle": "Editant seu {name}",
            "editMessage": "La seu ha estat editat",
            "addTitle": "Agregant nou seu"
        },
        "mylink": {
            "title": "Els meus links",
            "linkForms": "Enllaços a formularis",
            "linkUser": "Enllaços a inici sessió d'usuari",
            "linkWhistleblower": "Enllaç estat de la teva consulta"
        },
        "statistic": {
            "title": "Les meves estadístiques"
        }
    },
    "mUser": {
        "mydata": {
            "title": "Les meves dades"
        },
        "chistory": {
            "title": "Historial de casos",
            "titleAnalysis": "Historial de casos > Anàlisis",
            "titleDecision": "Historial de casos > Decisió",
            "titleComunication": "Historial de casos > Comunicació",
            "date": "Data",
            "type": "Tipus",
            "user": "Tancat per",
            "code": "Codi",
            "governingBody": "Òrgan de govern",
            "compliance": "Compliance Officer",
            "consult": "Consulta",
            "anonymous": "Anònima",
            "nominal": "Nominal",
            "case": "CAS",
            "seecomunication": "Denunciant"
        },
        "ocases": {
            "title": "Casos oberts",
            "time": "Termini",
            "intime": "En termini",
            "outtime": "Fora de termini",
            "titleAnalysis": "Casos oberts > Anàlisis",
            "titleDecision": "Casos oberts > Decisió",
            "titleComunication": "Casos oberts > Comunicació",
            "date": "Data",
            "type": "Tipus",
            "question": "Pregunta",
            "answer": "Resposta",
            "nature": "Naturalesa",
            "phase": "Fase",
            "user": "Assignat a",
            "code": "Codi",
            "governingBody": "Òrgan de govern",
            "compliance": "Compliance Officer",
            "consult": "Consulta",
            "anonymous": "Anònima",
            "nominal": "Nominal",
            "danonymous": "Denúncia Anònima",
            "dnominal": "Denúncia Nominal",
            "isCrime": "Hi ha algun delicte relacionat amb la consulta/denuncia?",
            "crimes": "Introdueixi el/els delictes associats",
            "investigation": "Recerques",
            "author": "Autor",
            "uploadFile": "Arxius pujats pel denunciant",
            "files": {
                "name": "Nom",
                "date": "Data",
                "download": "Descarregar"
            },
            "authors": {
                "name": "Nom",
                "date": "Data"
            },
            "close": "Tancar consulta",
            "closedenu": "Tancar fase",
            "invPhase": {
                "title": "Recerca fase",
                "text": "Resposta",
                "cause": "Anàlisi de les causes",
                "observation": "Observacions",
                "relevant": "És pertinent?",
                "conclusionPhase2": "Conclusió final",
                "yes": "Si",
                "no": "No"
            },
            "falsa": "Denúncia Falsa",
            "avisoFAS": "En donar-li al botó enviar, es finalitzarà la denúncia",
            "ajenos": "Dades personals alienes",
            "sensibles": "Dades Sensibles",
            "anadirusuario": "Afegir usuari a la recerca",
            "asistenteia": "Assistent IA",
            "newPregunta": "Nova pregunta",
            "falseMensaje": "S'emprendran accions legals?",
            "exportCase": "Exportar cas",
            "caseType": "Tipus de cas: ",
            "create": "CREADA",
            "analysis": "ANÀLISI",
            "decision": "DECISIÓ",
            "comunication": "COMUNICACIÓ",
            "finished": "FINALITZADA",
            "deleteTitle": "Esborrant arxiu",
            "deleteMessage": "Està segur que desitja eliminar l'arxiu?",
            "relevant": "És pertinent?",
            "attachFile": "Arxiu adjunt:",
            "seephase": "Anàlisi",
            "high": "ALTA",
            "medio": "MITJANA",
            "low": "BAIXA",
            "priorityComplaint": "Prioritat de la denúncia",
            "activateFiles": "Activar pujada d'arxius al denunciant",
            "activateMessages": "Activar zona de missatges al denunciant",
            "mensajeConfirmacion": "Està vostè segur que desitja tancar la fase? No es pot tornar enrere",
            "phase3": {
                "title": "CAS ",
                "final": "Decisió final",
                "people": "Decisions sobre les persones afectades",
                "compliance": "Decisions sobre el Sistema de Compliance",
                "organization": "Decisions sobre l'operativa de treball de l'organització",
                "compliant": "Decisions sobre altres parts interessades implicades en la denúncia",
                "comunication": "Decisions sobre la comunicació",
                "other": "Unes altres deciciones",
                "observation": "Observacions",
                "save": "Guardar",
                "close": "Tancar",
                "btnpeople": "Persones afectades",
                "btncompliance": "Sistema de Compliance",
                "btnorganization": "Treball de l'organització",
                "btncompliant": "Altres parts interessades implicades",
                "btncomunication": "Comunicació",
                "btnother": "Unes altres",
                "message": "El text de la consulta/denuncia és: ",
                "messagedenu": "El text de la consulta/denuncia és: ",
                "seephase": "Decisió",
                "return": "Tornar",
                "cause": "Causes fase",
                "observationphase2": "Observació de la fase",
                "relevant": "És pertinent",
                "conclusionPhase2": "Conclusió fase",
                "nodecision": "La denúncia no té decisions",
                "decisionfinal": "Decisió final"
            },
            "phase4": {
                "title": "CAS ",
                "people": "Comunicacions a les persones afectades",
                "responsible": "Comunicacions als Responsables de les persones afectades",
                "organization": "Comunicació a la resta de persones de l'organització",
                "compliant": "Comunicació al denunciant",
                "adminpublic": "Comunicació a l'administració pública",
                "other": "Comunicació a altres parts interessades",
                "observation": "Observacions",
                "save": "Guardar",
                "close": "Tancar",
                "btnpeople": "Persones afectades",
                "btnresponsible": "Responsables",
                "btnorganization": "Resta de l'organització",
                "btncompliant": "Denunciant",
                "btnadminpublic": "Administració pública",
                "btnother": "Unes altres",
                "message": "El text de la consulta/denuncia és: ",
                "messagedenu": "El text de la consulta/denuncia és: ",
                "seephase": "Comunicació",
                "return": "Tornar",
                "cause": "Causes fase",
                "observationphase2": "Observació de la fase",
                "relevant": "És pertinent",
                "conclusionPhase2": "Conclusió fase",
                "channel": "Canal / mitjà de comunicació usat",
                "email": "Correu electrònic",
                "phone": "Telèfon",
                "presencial": "Presencial",
                "otherchannel": "Uns altres",
                "nocomunication": "La denúncia no té comunicacions",
                "resolucion": "Informació de resolució al denunciant",
                "ultentrada": "Últim Accés"
            },
            "messages": {
                "date": "Data",
                "text": "Missatge",
                "title": "Missatges"
            },
            "filesUsu": {
                "title": "Arxius del denunciant"
            },
            "InviUsu": {
                "title": "Usuaris Afegits",
                "name": "Nom",
                "motivo": "Motiu"
            }
        }
    },
    "mwhistleblower": {
        "title": "Denunciant",
        "case": "CAS - ",
        "uploadFile": "Pujar arxius",
        "message": "Missatges",
        "state": "ESTAT ACTUAL DE LA DENÚNCIA/CONSULTA: ",
        "finished": "ESTAT ACTUAL DE LA DENÚNCIA/CONSULTA: FINALITZADA",
        "comunication": "ESTAT ACTUAL DE LA DENÚNCIA/CONSULTA: COMUNICACIÓ",
        "decision": "ESTAT ACTUAL DE LA DENÚNCIA/CONSULTA: DECISIÓ",
        "analysis": "ESTAT ACTUAL DE LA DENÚNCIA/CONSULTA: EN CURS",
        "created": "ESTAT ACTUAL DE LA DENÚNCIA/CONSULTA: CREADA",
        "messagetext": "Escrigui aquí el seu missatge...",
        "messageTitle": "Missatge"
    },
    "phases": {
        "actions": {
            "close": "Tancar Cas",
            "save": "Guardar",
            "addFile": "Adjuntar nou arxiu",
            "seeFiles": "Veure historial d'arxius",
            "seePDF": "Veure historial PDF"

        },
        "id": "ANEU",
        "date": "Data",
        "type": "Tipus",
        "state": "Estat",
        "lastUser": "Últim usuari",
        "commentary": "Comentari"
    },
    "statistics": {
        "title": "FILTRE",
        "date_ini": "Data Inici",
        "date_fin": "Data fi",
        "type": "Tipus",
        "relation": "Relació",
        "font": "Font",
        "nature": "Naturalesa",
        "priority": "Prioritat",
        "appropriate": "Procedent",
        "msede": "Seu",
        "mdepa": "Departament",
        "state": "Estat",
        "create": "Creada",
        "analysis": "Anàlisi",
        "decision": "Decisió",
        "fin": "Finalitzada",
        "consulta": "Consulta",
        "anonimo": "Anònim",
        "nominal": "Nominal",
        "Tcreate": "CREADES",
        "Tanalysis": "ANÀLISI",
        "Tdecision": "DECISIÓ",
        "Tcomunicacion": "COMUNICACIÓ",
        "Tfin": "FINALITZADES",
        "nomfont": "NOMENI FONT",
        "numfont": "TOTAL",
        "total": "Total denúncies",
        "ptotal": "Percentatge total",
        "filter": "Filtrades",
        "pfilter": "Percentatge filtrades",
        "resume": "RESUM",
        "pstate": "PER ESTAT",
        "pfuente": "PER FONT",
        "department": "DEPARTAMENT",
        "sede": "SEU",
        "listdenu": "DETALL",
        "date": "Data"
    },
    "search": {
        "title": "Cercador de denúncies/consultes per codi",
        "search": "Buscar",
        "code": "Codi",
        "whistleblower": "Denunciant"
    },
    "errors": {
        "0": "Dades emmagatzemades correctament",
        "1": "S'ha produït un error.",
        "1.1": "Revisi les dades del formulari",
        "2": "Ja existeix el registre",
        "3": "No existeixen registres",
        "4": "Usuari desbloquejat",
        "8": "Usuari bloquejat",
        "5": "Empresa desbloquejada",
        "9": "Empresa bloquejada",
        "6": "Ha ocorregut un error. Intenti-ho de nou més tard.",
        "7": "Ha de seleccionar un certificat per a poder tancar el cas",
        "title": "Avís",
        "fieldOb": "Ha d'emplenar tots els camps obligatoris (*) i acceptar la política de privacitat",
        "comment": "Els camps amb * són obligatoris",
        "comment2": "Tots els camps amb asterisc (*) són obligatoris d'emplenar.",
        "acuse": "Justificant de recepció",
        "errorEmail": "El format de l'email no és vàlid"
    },
    "export": {
        "title": "Exportar",
        "case": "Cas",
        "name": "Nom: ",
        "surname": "Cognoms: ",
        "email": "Correu electrònic: ",
        "phone": "Telèfon: ",
        "relation": "Relació: ",
        "organization": "Organització: ",
        "nature": "Naturalesa: ",
        "offense": "Delicte: ",
        "consultation": "Consulta: ",
        "type": "Tipus: ",
        "department": "Departament: ",
        "priority": "Prioritat: ",
        "headquarters": "Seu: "
    },
    "configuration": {
        "email": "Correu electrònic",
        "user": "Usuari",
        "password": "Contrasenya",
        "server": "Servidor",
        "port": "Port",
        "security": "Seguretat",
        "nosec": "Sense seguretat",
        "footer": "Peu legal RGPD",
        "save": "Guardar configuració",
        "repeatPassword": "Repeteixi la contrasenya",
        "messageError": "Les contrasenyes són diferents",
        "messageError2": "La contrasenya ha de tenir almenys 8 caractéres i contenir una mayúsucula, una minúscula, un número i un símbol.",
        "change": "Gravar",
        "changePassword": "Canvi de contrasenya",
        "newPassword": "Nova contrasenya",
        "pprivacity": "Url Política de Privacitat",
        "advise": "Si és la primera vegada que entres, ves al final del formulari i canvia la clau d'empresa."
    },
    "legal": {
        "cookieNotice": "Aquest portal web únicament utilitza cookies pròpies amb finalitat tècnica, no recapta ni cedeix dades de caràcter personal dels usuaris sense el seu coneixement. No obstant això, conté enllaços a llocs web de tercers amb polítiques de privacitat alienes a la nostra que vostè podrà decidir si accepta o no quan accedeixi a ells. Si desitja més informació, consulti la nostra Política de Cookies prement ",
        "cookieNoticeRef": "aquí",
        "pprivacity": "Política de Privacitat",
        "legalWarn": "Avís Legal",
        "pcookies": "Política de Cookies",
        "asistenteIa": "La informació proporcionada per aquesta intel·ligència artificial té exclusivament finalitats informatives i no s'ha d'interpretar com a assessorament legal ni professional en cap sentit. Per a una orientació específica, es recomana consultar amb un professional qualificat."
    }
}